import React from "react"
import { Link } from "gatsby"
import Text from "../lazy-loaders/text"
import styles from "./brand_voice.module.scss"

interface TimelineItem {
  text: string
  title?: string
}

interface Props {
  title: string
  introText: string
  timelineItems?: TimelineItem[]
  className?: string
}
export default ({ title, introText, timelineItems, className }: Props) => (
  <div className={`${styles.brandVoice} ${className ? ` ${className}` : ""}`}>
    <h2 className={styles.title}>
      <Text text={title} />
    </h2>
    <div className={styles.introText}>
      <Text animateLines={true} text={introText} />
      <p className={`display4`}>Join us for the next chapter at...</p>
      <Link
      to={"https://thinkerbell.com/"}
      className={`${styles.button} label1 hovertarget`}
    >
      Thinkerbell.com
    </Link>
    </div>
  </div>
)
